import css from "styled-jsx/css";
import colors from "/styles/colors";
import { TABLET_QUERY_MIN_WIDTH } from "constants/vp-sizes";

export const componentStyles = css`
  .person-component {
    display: flex;
    align-items: center;

    .person-image {
      margin-right: 1.5vw;
      img {
        border-radius: 50%;
        height: 5vw;
        min-height: 32px;
      }
    }

    .text-container {
      display: flex;
      flex-direction: column;
      text-align: left;
      line-height: 3vw;

      .text {
        font-size: 2vw;

        @media (max-width: ${TABLET_QUERY_MIN_WIDTH}) {
          font-size: 1.125rem;
          line-height: 24px;
        }

        a,
        span {
          font-weight: 400;
        }
      }

      .name-and-vendor-container {
        .person-name {
          text-decoration: none;
          color: ${colors["black"]};
          font-family: "Reenie Beanie", cursive;
          font-size: 2.5vw;

          @media (max-width: ${TABLET_QUERY_MIN_WIDTH}) {
            font-size: 1.375rem;
          }
        }
        .vendor-name {
          color: ${colors["black"]};
          text-decoration: none;
        }
      }
    }
  }
`;
